"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.ArenguForm = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

const ARENGU_SDK_LOADED = `af-init`;
/**
 * Component to render a form from Arengu
 */

class ArenguForm extends _react.default.Component {
  constructor() {
    super();
    this.ref = null;
    this.saveRef = this.saveRef.bind(this);
  }

  setHiddenFields(form) {
    const hiddenFields = this.props.hiddenFields;

    if (hiddenFields) {
      return hiddenFields.forEach(o => {
        form.setHiddenField(o.key, o.value);
      });
    }

    return null;
  }

  initSdk() {
    const id = this.props.id;
    return window.ArenguForms.embed(id, this.ref).then(form => this.setHiddenFields(form));
  }

  removeListeners() {
    document.removeEventListener(ARENGU_SDK_LOADED, this.initSdk());
  }

  waitLoadEventAndInitSdk() {
    document.addEventListener(ARENGU_SDK_LOADED, this.initSdk());
  }

  saveRef(ref) {
    this.ref = ref;
  }

  componentDidMount() {
    if (window.ArenguForms) {
      this.initSdk();
    } else {
      this.waitLoadEventAndInitSdk();
    }
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  render() {
    return _react.default.createElement("div", {
      ref: this.saveRef
    });
  }

}

exports.ArenguForm = ArenguForm;
ArenguForm.propTypes = {
  /** Form ID to be rendered */
  id: _propTypes.default.string.isRequired,

  /** Array of hidden fields to bet set */
  hiddenFields: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Key of your hidden field */
    key: _propTypes.default.string,

    /** Value of your hidden field */
    value: _propTypes.default.string
  }))
};
var _default = ArenguForm;
exports.default = _default;